@if (options().length === 0) {
    <p class="empty">{{ emptyText() }}</p>
} @else {
    <ul class="list">
        @for (option of options(); track option.value) {
            <li>
                <!-- Each option is its own toggle button, so aria-pressed reports the
                     selection without a listbox's roving focus. -->
                <button
                    class="option"
                    type="button"
                    [class.selected]="isSelected(option)"
                    [attr.aria-pressed]="isSelected(option)"
                    (click)="toggle(option)"
                >
                    @if (option.avatarName) {
                        <app-cerrix-avatar [name]="option.avatarName" />
                    }
                    <span class="label">{{ option.label }}</span>
                </button>
            </li>
        }
    </ul>
}
